(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Editkoz_Handler = (function(superClass) {
    extend(Editkoz_Handler, superClass);

    function Editkoz_Handler() {
      return Editkoz_Handler.__super__.constructor.apply(this, arguments);
    }

    Editkoz_Handler.prototype.init = function() {
      this.sidebar_open = false;
      this.layoutUrl = 'backend/portal/editkoz/';
      this.saveUrl = 'backend/portal/editkoz/save';
      return this.createDialog();
    };

    Editkoz_Handler.prototype.afterLoadLayout = function(selector, response) {
      var height, id, ref;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      this.data = response.data;
      this.table = $('.handsontable');
      height = this.dialog.find('.modal-body').height();
      this.table.height(height + 'px');
      this.data.kpo = $.map(this.data.kpo, function(value, index) {
        return [value];
      });
      this.table.handsontable({
        data: this.data.kpo,
        rowHeaders: this.data.rowHeaders,
        colHeaders: this.data.colHeaders,
        currentRowClassName: 'highlighted',
        currentColClassName: 'highlighted',
        columns: (function() {
          var i, len, ref1, results;
          ref1 = this.data.hybridIds;
          results = [];
          for (i = 0, len = ref1.length; i < len; i++) {
            id = ref1[i];
            results.push({
              data: 'hybrid' + id + '.kpo'
            });
          }
          return results;
        }).call(this),
        maxRows: this.data.rowHeaders.length,
        maxCols: this.data.colHeaders.length,
        beforeChange: function(changes, source) {
          var cell, col, i, len;
          for (i = 0, len = changes.length; i < len; i++) {
            cell = changes[i];
            if (isNaN(parseFloat(cell[3])) || !isFinite(cell[3]) || parseFloat(cell[3]) < 0 || parseInt(cell[3]) > 1000) {
              return false;
            } else if ((parseFloat(cell[3]) === -0) || (parseFloat(cell[3]) === +0)) {
              cell[3] = 0;
            } else {
              col = cell[1].match(/.*[^.kpo]/);
              this.getSourceDataAtRow(cell[0])[col[0]].changed = true;
            }
          }
          return true;
        }
      });
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          var cell, changedData, i, key, len, ref1, row;
          changedData = [];
          ref1 = _this.data.kpo;
          for (i = 0, len = ref1.length; i < len; i++) {
            row = ref1[i];
            for (key in row) {
              cell = row[key];
              if (cell.changed === true) {
                changedData.push(cell);
              }
            }
          }
          _this.saveData = {
            kpo: JSON.stringify(changedData)
          };
          return _this.save('Saving K/Oz...');
        };
      })(this));
      return $(window).unbind('modal_resized').bind('modal_resized', debounce((function(_this) {
        return function(e) {
          return _this.resize();
        };
      })(this)));
    };

    Editkoz_Handler.prototype.resize = function() {
      var height;
      height = this.dialog.find('.modal-body').height();
      return this.table.height(height + 'px');
    };

    return Editkoz_Handler;

  })(FullPageHandler);

}).call(this);
